import { Survey } from "@tree-company/tree-query";
import { QuestionPage } from "./components/question";
import questions from "./data/questions.json";
import { ResultPage } from "./components/result";
import PROFILES from "./data/profiles";
import locales from "./locales";
import { calculateResults } from "./helpers/helpers";
import { ActionPlan, ChooseActionQuestion } from "./views/action_plan";
export const totalQuestions = questions.length;

let responseCollectorURL = import.meta.env.VITE_COLLECTOR_URL;
if (import.meta.env.DEV && responseCollectorURL === undefined) {
  responseCollectorURL = "http://localhost:3000";
}

export function makeQuestion(question) {
  return {
    type: "radio",
    order: 1,
    required: true,
    key: `vraag${question.id}`,
    title: { nl: question.question },
    options: [
      {
        label: { nl: locales("questions.buttons.helemaal_oneens") },
        value: 1,
      },
      {
        label: { nl: locales("questions.buttons.eerder_oneens") },
        value: 2,
      },
      {
        label: { nl: locales("questions.buttons.neutraal") },
        value: 3,
      },
      {
        label: { nl: locales("questions.buttons.eerder_eens") },
        value: 4,
      },
      {
        label: { nl: locales("questions.buttons.helemaal_eens") },
        value: 5,
      },
    ],
  };
}

export function makeAction(profile, actionKey) {
  const category = profile[actionKey];
  return {
    type: "radio",
    order: 1,
    required: true,
    key: `action_${actionKey}`,
    renderKey: `${profile.id}-${actionKey}`,
    title: { nl: category.title },
    options: Object.entries(category.choices).map(([key, label]) => ({
      value: key,
      label: { nl: label },
    })),
    component: ChooseActionQuestion,
    skipIf: (treesponse) => {
      const selectedProfileIndex = calculateResults(treesponse);
      return selectedProfileIndex !== profile.index;
    },
  };
}

function makePage(question, index) {
  return {
    key: `page${index + 1}`,
    order: index + 1,
    disablePrevious: index < 1,
    title: { nl: "Hello" },
    component: QuestionPage,
    htmlAttributes: {
      class: "page--question",
    },
    sections: [makeQuestion(question)],
  };
}

export const survey = new Survey({
  key: "digitalewelzijn",
  availableLanguages: ["nl"],
  pages: [
    ...questions.sort((q1, q2) => q1.order - q2.order).map(makePage),
    {
      key: "profile",
      order: 7,
      sections: [
        {
          key: "profile",
          type: "hidden",
          defaultValue: (treesponse) => calculateResults(treesponse),
        },
        ...Object.values(PROFILES).map((p) => makeAction(p, "habits")),
        ...Object.values(PROFILES).map((p) => makeAction(p, "environment")),
        ...Object.values(PROFILES).map((p) => makeAction(p, "devices")),
      ],
      component: ActionPlan,
    },
    {
      key: "result",
      order: 8,
      title: { nl: "Mijn actieplan" },
      sections: [],
      htmlAttributes: {
        class: "page--background page--result",
      },
      component: ResultPage,
    },
  ],
  responseCollector: {
    apiSettings: {
      url: responseCollectorURL,
      projectKey: import.meta.env.VITE_COLLECTOR_KEY,
    },
    defaultValues: {
      surveyVersion: "v1",
      language: "nl",
    },
  },
});
